import React, { useRef } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import VerticalContentCardGrid from 'molecules/VerticalContentCardGrid/VerticalContentCardGrid';
import { IStaticContentfulVideos } from 'src/types/contentful';
import Stack from 'atoms/Layout/Stack/Stack';
import useLazyLoadedURL from 'src/hooks/useLazyLoadedURL';

const NativeMobileAppsVerticalCards = (): JSX.Element => {
  const { featuredVideo, posterImage } = useStaticQuery<IStaticContentfulVideos>(
    graphql`
      {
        featuredVideo: contentfulAsset(contentful_id: { eq: "5BueV4X4Iw95fEAuOw5Cat" }) {
          localFile {
            publicURL
          }
        }
        posterImage: contentfulAsset(contentful_id: { eq: "CtMe11noHZ1pAIdDmykhP" }) {
          localFile {
            publicURL
          }
        }
      }
    `
  );

  const containerRef = useRef<HTMLDivElement>(null);
  const videoSource = useLazyLoadedURL(containerRef, featuredVideo.localFile.publicURL, 0.1);

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      maxWidth='width-3xl'
      padding={['spacing-none', 'spacing-7xl']}
      paddingLg='spacing-none'
      ref={containerRef}
    >
      <VerticalContentCardGrid
        items={[
          {
            type: 'text-list',
            props: {
              verticalContentCardProps: {},
              verticalTextListProps: {
                titleItemProps: {
                  type: 'heading',
                  size: 'md',
                  fontWeight: 'font-weight-semibold',
                },
                descriptionItemProps: {
                  type: 'paragraph',
                  size: 'lg',
                  color: 'text-tertiary',
                },
                items: [
                  {
                    title: 'Native Development',
                    description: 'Skip the freemium community. Challenges and mini-courses convert best right now.',
                  },
                  {
                    title: 'Weekly App Updates',
                    description:
                      "Monthly themes. Weekly events. Daily questions — we'll show you how to set it up and why it works.",
                  },
                  {
                    title: '84% Member-Led Activity',
                    description:
                      "Live workshops. Small groups. An additional challenge — all add to the value you're creating.",
                  },
                  {
                    title: 'Branded Apps',
                    description: '4x your engagement by making your community a habit, not a bookmark.',
                  },
                ],
              },
            },
          },
          {
            type: 'image',
            props: {
              verticalContentCardProps: {},
              assetWrapperProps: {
                videoProps: {
                  src: videoSource,
                  poster: posterImage.localFile.publicURL,
                  autoPlay: true,
                  loop: true,
                  muted: true,
                  playsInline: true,
                },
                cover: {
                  autoHeight: true,
                },
                maxWidth: 480,
              },
            },
          },
        ]}
      />
    </Stack>
  );
};

export default NativeMobileAppsVerticalCards;
